"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MathManip2_exports = {};
__export(MathManip2_exports, {
  default: () => MathManip2_default
});
module.exports = __toCommonJS(MathManip2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.0195 3.16016C13.7096 3.16016 14.3542 3.29036 14.9531 3.55078C15.5651 3.8112 16.0924 4.16927 16.5352 4.625C16.9909 5.08073 17.349 5.60807 17.6094 6.20703C17.8698 6.81901 18 7.46354 18 8.14062C18 9.15625 17.7266 10.0677 17.1797 10.875C16.6458 11.6823 15.9492 12.2878 15.0898 12.6914L16.2812 15.1914C16.3333 15.2956 16.3529 15.4062 16.3398 15.5234C16.3268 15.6406 16.2878 15.7448 16.2227 15.8359C15.832 16.3568 15.2461 16.7409 14.4648 16.9883C13.6966 17.2227 12.7331 17.3398 11.5742 17.3398C10.4154 17.3398 9.44531 17.2227 8.66406 16.9883C7.89583 16.7409 7.31641 16.3568 6.92578 15.8359C6.86068 15.7578 6.8151 15.6732 6.78906 15.582C6.77604 15.4779 6.78906 15.3737 6.82812 15.2695L6.84766 15.1914L7.49219 13.8047H3.64453C3.47526 13.8047 3.33203 13.7526 3.21484 13.6484C3.09766 13.5312 3.02604 13.3945 3 13.2383V13.1602V6.24609C3 6.07682 3.05208 5.93359 3.15625 5.81641C3.27344 5.6862 3.41016 5.61458 3.56641 5.60156L3.64453 5.58203H8.76172C9.19141 4.86589 9.78385 4.28646 10.5391 3.84375C11.2943 3.38802 12.1211 3.16016 13.0195 3.16016ZM11.5352 8.04297L8.11719 15.3281L8.17578 15.3867C8.44922 15.5951 8.82682 15.7578 9.30859 15.875C9.79036 15.9922 10.3763 16.0638 11.0664 16.0898L11.3203 16.1094H11.5742C12.3555 16.1094 13.0195 16.0573 13.5664 15.9531C14.1133 15.8359 14.543 15.6732 14.8555 15.4648L14.9727 15.3867L15.0117 15.3477L11.5352 8.04297ZM8.21484 6.89062H4.26953V12.4961H8.11719L8.87891 10.8945C8.61849 10.4909 8.41667 10.0612 8.27344 9.60547C8.13021 9.13672 8.05859 8.64844 8.05859 8.14062C8.05859 7.93229 8.07161 7.72396 8.09766 7.51562C8.1237 7.30729 8.16276 7.09896 8.21484 6.89062ZM13.0195 4.56641C12.043 4.56641 11.2031 4.91797 10.5 5.62109C9.79688 6.3112 9.44531 7.15104 9.44531 8.14062C9.44531 8.33594 9.45833 8.53125 9.48438 8.72656C9.52344 8.90885 9.56901 9.09115 9.62109 9.27344L10.9883 6.36328C11.0924 6.14193 11.2552 6.02474 11.4766 6.01172C11.7109 5.9987 11.8932 6.08984 12.0234 6.28516L12.0625 6.36328L14.4844 11.4219C15.1094 11.1354 15.6172 10.6992 16.0078 10.1133C16.3984 9.52734 16.5938 8.86979 16.5938 8.14062C16.5938 7.15104 16.2422 6.3112 15.5391 5.62109C14.849 4.91797 14.0091 4.56641 13.0195 4.56641Z",
      fill: "currentColor"
    }
  )
);
const SvgMathManip2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MathManip2_default = SvgMathManip2;
